export default "__VITE_ASSET__8c3658f3__"